@if (shouldShow$ | async) {
  <div class="token-warning-banner visible">
    <div class="banner-content">
      <div class="warning-icon">
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <div class="warning-text">
        <span class="warning-title">{{ (tokenStatus$ | async)?.isExpired ? ('AUTH.SESSION.EXPIRED.TITLE' | translate) : ('AUTH.SESSION.WARNING.TITLE' | translate) }}</span>
        <span class="warning-message">
          {{ (tokenStatus$ | async)?.isExpired ? ('AUTH.SESSION.EXPIRED.MESSAGE' | translate) : ('AUTH.SESSION.WARNING.MESSAGE' | translate: { time: (expirationTimeFormatted$ | async) }) }}
        </span>
      </div>
      <div class="warning-actions">
        <button class="btn btn-outline-light btn-sm refresh-btn"
          (click)="handleSessionAction()"
          [title]="(tokenStatus$ | async)?.isExpired ? ('AUTH.SESSION.EXPIRED.REFRESH' | translate) : ('AUTH.SESSION.WARNING.REFRESH' | translate)">
          <i class="fas fa-sync-alt"></i>
          {{ (tokenStatus$ | async)?.isExpired ? ('AUTH.SESSION.EXPIRED.REFRESH' | translate) : ('AUTH.SESSION.WARNING.REFRESH' | translate) }}
        </button>
      </div>
      <button class="close-btn" (click)="dismissBanner()" title="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
}
